import React, { useState, useEffect } from 'react';
import Slider from "react-slick";
import { EventCardWidget } from "./EventCard.jsx";

export function EventListWidget({ configuration }) {
  const [events, setEvents] = useState(configuration.events || []);

  let title = configuration.translations.activeEvents;
  let introText = configuration.translations.introText;

  let out;
  if (events.length > 0) {
    out = (
      <div>
          <h2 className="eventListWidget-title">
            {title}
          </h2>
          <p>{introText}</p>

          <Slider {...configuration.settings} infinite={events.length > configuration.settings.slidesToShow}>
            {events.map(event =>
              <EventCardWidget
                key={event.pk}
                event={event}
                configuration={configuration}
              />
            )}
          </Slider>
      </div>
    );
  } else {
    out = "";
  }

  return out;
}
